import { type CivilDate, compareCivilDate } from '~/models/civilDate'

/**
 * 対象日 (targetDate) 時点でマスタ (validFrom/validTo) が有効かどうかを判定する
 * (occto-master-fk-as-of-filter 設計書 Decision 2/3、AC-MOI-023)。
 *
 * - targetDate < validFrom → false (適用開始日未到達)
 * - validTo !== undefined かつ targetDate > validTo → false (validTo は包含 `<=`。
 *   「供給終了日 3/31 なら 3/31 は計上」= mock-app domain-knowledge.md §31f 準拠)
 * - それ以外 → true (targetDate === validTo は有効)
 *
 * 旧 `AdminOcctoMaster/tabs/_common/models/validPeriod.ts` から昇格 (issue #5219
 * review 指摘): `WorkflowCases/models/bgCandidates.ts` が page 境界を跨いで
 * import していたため、複数 page で使う共有 model として `src/models/` へ移した
 * (frontend/apps/ebalance/CLAUDE.md「page固有のcomponent / hook / modelは
 * src/pages/<Page>/ に置き、複数pageで実際に使われてから共有directoryへ昇格する」)。
 */
export function isActiveOn(
  validFrom: CivilDate,
  validTo: CivilDate | undefined,
  targetDate: CivilDate,
): boolean {
  if (compareCivilDate(targetDate, validFrom) < 0) return false
  if (validTo !== undefined && compareCivilDate(targetDate, validTo) > 0) {
    return false
  }
  return true
}
